// extracted by mini-css-extract-plugin
export default {"star":"PersonFavorite_star__qZ8dh","star__img":"PersonFavorite_star__img__WEa5D"};